const selector = '[data-sc-product-photo-reveal]';
const controllers = new WeakMap();
function galleriesWithin(root) {
  return [...(root.matches?.(selector) ? [root] : []), ...root.querySelectorAll(selector)];
}
function initGallery(gallery) {
  if (controllers.has(gallery)) return;
  const photos = [...gallery.querySelectorAll('img')];
  if (!photos.length || matchMedia('(prefers-reduced-motion: reduce)').matches || !('IntersectionObserver' in window)) return;
  const controller = new AbortController();
  const observer = new IntersectionObserver(entries => {
    entries.filter(entry => entry.isIntersecting).sort((a, b) => photos.indexOf(a.target) - photos.indexOf(b.target)).forEach((entry, index) => {
      const photo = entry.target;
      observer.unobserve(photo);
      const reveal = () => {
        if (controller.signal.aborted) return;
        photo.style.setProperty('--sc-photo-delay', Math.min(index, 4) * 110 + 'ms');
        photo.classList.remove('sc-detail-photo-pending');
        photo.classList.add('sc-detail-photo-visible');
      };
      if (photo.complete) reveal();
      else {
        photo.addEventListener('load', reveal, { once: true, signal: controller.signal });
        photo.addEventListener('error', reveal, { once: true, signal: controller.signal });
      }
    });
  }, { threshold: 0.05 });
  controllers.set(gallery, { observer, controller });
  photos.forEach(photo => {
    photo.classList.add('sc-detail-photo-pending');
    observer.observe(photo);
  });
}
function initWithin(root) {
  galleriesWithin(root).forEach(initGallery);
}
initWithin(document);
document.addEventListener('shopify:section:load', event => initWithin(event.target));
document.addEventListener('shopify:section:unload', event => {
  galleriesWithin(event.target).forEach(gallery => {
    const state = controllers.get(gallery);
    if (!state) return;
    state.observer.disconnect();
    state.controller.abort();
    controllers.delete(gallery);
  });
});
